import React from "react";
import PropTypes from "prop-types";
import { LightOnIcon, LightOffIcon } from "../../Icons";
import { Image } from "@learningblocks/shared-components";

export function Light(props) {
  const getLightImage = () => {
    if (props.isOn) {
      return LightOnIcon;
    } else {
      return LightOffIcon;
    }
  };

  return (
    <Image
      className={props.className}
      onClick={props.toggleIsOn}
      src={getLightImage()}
      alt={`Light: it is ${props.isOn ? "on" : "off"}`}
    />
  );
}

Light.propTypes = {
  /**
   * ClassName for component
   */
  className: PropTypes.string,
  /**
   * Type of Cuvette Rack
   */
  isOn: PropTypes.bool,

  toggleIsOn: PropTypes.func,
};

Light.defaultProps = {
  isOn: false,
};
